import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  OnDestroy,
  OnInit,
  output,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ToggleOption } from '../option.interface';

@Component({
  selector: 'lib-icon-button-toggle',
  imports: [ReactiveFormsModule],
  templateUrl: './icon-button-toggle.component.html',
  styleUrl: './icon-button-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class IconButtonToggleComponent implements OnInit, OnDestroy {
  subscription = new Subscription();

  id = input.required<string>();
  formGroup = input.required<FormGroup>();
  inputFormControlName = input.required<string>();
  label = input<string>();
  options = input<ToggleOption>();
  disabled = input<boolean>(false);
  required = input<boolean>(false);

  valueChange = output<{ key: string; toggleValue: boolean }>();

  isActive(): boolean {
    return this.formGroup().get(this.inputFormControlName())?.value === true;
  }

  constructor() {
    effect(() => {
      const control = this.formGroup().get(this.inputFormControlName());
      if (control) {
        this.disabled() ? control.disable() : control.enable();
      }
    });
  }

  ngOnInit() {
    this.initControl();
    this.subscribeToValueChanges();
  }

  private initControl(): void {
    const control = this.formGroup().get(this.inputFormControlName());
    if (!control) return;

    if (control.value == null) control.setValue(false);
    if (this.disabled()) control.disable();
    if (this.required()) {
      control.setValidators([Validators.requiredTrue]);
      control.updateValueAndValidity();
    }
  }

  onToggle(): void {
    if (this.disabled()) return;
    const control = this.formGroup().get(this.inputFormControlName());
    if (control) {
      control.setValue(!control.value);
      control.markAsDirty();
    }
  }

  subscribeToValueChanges() {
    this.subscription.add(
      this.formGroup()
        .get(this.inputFormControlName())
        ?.valueChanges.subscribe(res => {
          this.valueChange.emit({
            key: this.inputFormControlName(),
            toggleValue: res,
          });
        })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
